import React, { useState } from 'react';

import { colors } from 'global/colors';
import Collapse from 'components/collapse';
import { Wrapper, Container } from '../../components';
import { Header, HeadingContainer } from '../ChallengeListPage/styles';
import CurvedContainer from '../../components/CurvedContainer';

import { candidatesFaqContent, recruitersFaqContent } from './data';
import { Heading } from './styles';

export default function FAQPage() {
  const [recruiterAccordion, setRecruiterAccordion] = useState(recruitersFaqContent);
  const [candidateAccordion, setCandidateAccordion] = useState(candidatesFaqContent);

  return (
    <Wrapper color="transparent">
      <CurvedContainer bottom height={110} color={colors.darkBlue} />
      <Container column>
        <HeadingContainer>
          <Header>Frequently Asked Questions</Header>
        </HeadingContainer>

        <Heading>Recruiters' FAQ</Heading>
        {recruiterAccordion.map((question, index) => (
          <Collapse
            key={index}
            title={question.title}
            id={index}
            isCollapsed={!question.active}
            action={() => {
              let temp = [...recruiterAccordion];
              temp[index]['active'] = !temp[index]['active'];
              setRecruiterAccordion(temp);
            }}
          >
            <div>{question.data}</div>
          </Collapse>
        ))}

        <Heading>Candidates' FAQ</Heading>
        {candidateAccordion.map((question, index) => (
          <Collapse
            key={index}
            title={question.title}
            id={index}
            isCollapsed={!question.active}
            action={() => {
              let temp = [...candidateAccordion];
              temp[index]['active'] = !temp[index]['active'];
              setCandidateAccordion(temp);
            }}
          >
            <div>{question.data}</div>
          </Collapse>
        ))}
      </Container>
    </Wrapper>
  );
}
